module.exports = __webpack_public_path__ + "media/images/ly-624d65c32c94bab9d32d54a6e7ad7b78.png";